import React from 'react'
import styles from './styles.css'
import Buttons from './Buttons'
import PropTypes from 'prop-types'
import {withRouter} from 'react-router'

@withRouter
export default class Title extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    document: PropTypes.object,
    url: PropTypes.bool,
    params: PropTypes.object
  }

  render() {
    //console.log("Generando titulo");
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <div className="row">
              <div className="col-xs-12 col-sm-4 col-md-3 col-lg-2">
                <h3 className={styles.title}>Documento:</h3>
              </div>
              <div className="col-xs-12 col-sm-8 col-md-7 col-lg-7">
                <h3 className={styles.name}>{this.props.document.name}</h3>
              </div>
            </div>
          </div>
          <Buttons document={this.props.document} params={this.props.params} url={this.props.url} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/Status/Title/index.js